import { AxiosResponse } from "axios"
import SecureClient from "../SecureClient"
import { WorkflowFailureActionConfiguration } from "./DTOs"

export default class WorkflowFailureActionsClient extends SecureClient {

	/**
	 *
	 */
	constructor() {
		super()

	}

	public getFailureActions = (): Promise<AxiosResponse<WorkflowFailureActionConfiguration[]>> => {
		return this._api.get<WorkflowFailureActionConfiguration[]>(`WorkflowFailureActions`, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}

	public getFailureAction = (failureActionId: string): Promise<AxiosResponse<WorkflowFailureActionConfiguration>> => {
		return this._api.get<WorkflowFailureActionConfiguration>(`WorkflowFailureActions/${failureActionId}`, {
			headers: {
				...this.authorizationHeader,
				...this.acceptHeader(),
				...this.contentTypeHeader()
			}
		})
	}


}